let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3e5gt")).then(() => parcelRequire('4LrFA'));